/* FP Quiz exit popup — invites longer-browsing visitors to the quiz.
   Shows only after a minimum of cumulative browsing time (default 2 minutes,
   tracked across pages), then on exit intent (desktop) or next page view
   (mobile). Never shown after quiz completion or signup, never alongside the
   welcome popup, and respects a dismissal cooldown. */
(function () {
  'use strict';

  var root = document.getElementById('fp-quiz-popup');
  if (!root) return;

  var STORE_KEY = 'fp_qp_state_v1';
  var TIME_KEY = 'fp_browse_seconds_v1';
  var cfg = {
    browseSeconds: parseInt(root.getAttribute('data-browse-seconds'), 10) || 120,
    repeatDays: parseInt(root.getAttribute('data-repeat-days'), 10) || 14,
    quizUrl: root.getAttribute('data-quiz-url') || '/pages/quiz',
    exclude: (root.getAttribute('data-exclude') || '')
      .split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean)
  };

  var dialog = root.querySelector('.fp-wp');
  var opened = false;
  var lastFocused = null;

  function readJSON(key) {
    try { return JSON.parse(localStorage.getItem(key)) || {}; } catch (e) { return {}; }
  }
  function writeState(patch) {
    var s = readJSON(STORE_KEY);
    for (var k in patch) { if (Object.prototype.hasOwnProperty.call(patch, k)) s[k] = patch[k]; }
    try { localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function track(name, payload) {
    window.dataLayer = window.dataLayer || [];
    var d = { event: name };
    for (var k in payload) { if (Object.prototype.hasOwnProperty.call(payload, k)) d[k] = payload[k]; }
    window.dataLayer.push(d);
  }

  /* ---- Cumulative browse-time tracking (across pages, only while visible) ---- */
  function browseSeconds() {
    try { return parseInt(localStorage.getItem(TIME_KEY), 10) || 0; } catch (e) { return 0; }
  }
  var tickTimer = setInterval(function () {
    if (document.visibilityState === 'visible') {
      try { localStorage.setItem(TIME_KEY, String(browseSeconds() + 5)); } catch (e) {}
    }
  }, 5000);

  function pathExcluded() {
    var p = window.location.pathname.toLowerCase();
    for (var i = 0; i < cfg.exclude.length; i++) {
      if (cfg.exclude[i] && p.indexOf(cfg.exclude[i]) === 0) return true;
    }
    return false;
  }

  function shouldShow() {
    if (pathExcluded()) return false;
    try { if (localStorage.getItem('fp_quiz_done')) return false; } catch (e) {}
    var wp = readJSON('fp_wp_state_v1');
    if (wp.subscribed) return false; /* already on the list via welcome popup */
    var welcomeOpen = document.querySelector('#fp-welcome-popup.is-open');
    if (welcomeOpen) return false;
    var s = readJSON(STORE_KEY);
    if (s.clicked) return false;
    if (s.dismissedAt) {
      var days = (Date.now() - s.dismissedAt) / 86400000;
      if (days < cfg.repeatDays) return false;
    }
    if (s.shownThisSession) return false;
    return browseSeconds() >= cfg.browseSeconds;
  }

  /* ---- Focus management ---- */
  function focusables() {
    return Array.prototype.slice.call(dialog.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { close('escape'); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (opened || !shouldShow()) return;
    opened = true;
    lastFocused = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown);
    var f = focusables();
    if (f.length) f[0].focus();
    writeState({ shownAt: Date.now() });
    try { sessionStorage.setItem('fp_qp_shown', '1'); } catch (e) {}
    track('quiz_popup_shown', {});
  }

  function close(reason) {
    if (!opened) return;
    opened = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    writeState({ dismissedAt: Date.now() });
    track('quiz_popup_dismissed', { popup_dismiss_reason: reason || 'close' });
  }

  /* ---- Bindings ---- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-fp-qp-close]'), function (el) {
    el.addEventListener('click', function () { close(el.getAttribute('data-fp-qp-close')); });
  });
  root.addEventListener('mousedown', function (e) {
    if (e.target === root) close('backdrop');
  });
  var go = root.querySelector('[data-fp-qp-go]');
  if (go) {
    go.addEventListener('click', function () {
      writeState({ clicked: Date.now() });
      track('quiz_popup_click', {});
      /* natural navigation to the quiz proceeds */
    });
  }

  /* ---- Session guard: once per session ---- */
  try { if (sessionStorage.getItem('fp_qp_shown')) return; } catch (e) {}

  /* ---- Triggers ---- */
  var isDesktop = window.matchMedia('(min-width: 750px)').matches;
  if (isDesktop) {
    document.addEventListener('mouseout', function onOut(e) {
      if (e.clientY > 0 || e.relatedTarget) return;
      if (!shouldShow()) return;
      document.removeEventListener('mouseout', onOut);
      open();
    });
  } else {
    /* Mobile has no exit intent: show on a page view once the browsing
       threshold has been met, after a polite pause. */
    setTimeout(function () { open(); }, 4000);
  }
})();
